import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils';

/* Put all uiSchema options here, in the template they go under ui:options: */
export const InputGroupArrayCheckboxCardUiOptionsSchema = z.object({
  // Add your UI options here if needed
});

// Transforms the Zod schema to a TypeScript type
export type InputGroupArrayCheckboxCardUiOptions = z.infer<
  typeof InputGroupArrayCheckboxCardUiOptionsSchema
>;

/* The field schema for the InputGroupArrayCheckboxCard field extension */
export const InputGroupArrayCheckboxCardFieldSchema = makeFieldSchemaFromZod(
  z.array(z.object({})).describe('Array Two Fields In Card'),
  InputGroupArrayCheckboxCardUiOptionsSchema,
);

// Transforms the field schema props to a TypeScript type
export type InputGroupArrayCheckboxCardFieldProps =
  typeof InputGroupArrayCheckboxCardFieldSchema.type;

/* The final schema used for the field extension */
export const InputGroupArrayCheckboxCardSchema =
  InputGroupArrayCheckboxCardFieldSchema.schema;
